module.exports = __webpack_public_path__ + "media/images/riders/GITTHA_MICHIELS-dd59596cfaaacedddb1a02c7bda3e3ff.png";